import { useCallback } from 'react';

import {
   InteractiveTable,
   InteractiveTableCellProps,
   OnCheckboxSelectionChange,
   useInteractiveTableContext,
} from '@dreryk/react-components';

import { MedicineRawMaterialTableBean } from './MedicineRawMaterialTable.types';

type RpwCheckboxCellProps = InteractiveTableCellProps<boolean>;

export const RpwCheckboxCell = (props: RpwCheckboxCellProps): JSX.Element => {
   const { setCellValue } = useInteractiveTableContext<MedicineRawMaterialTableBean>();

   const handleSelectionChange = useCallback<OnCheckboxSelectionChange>(
      (selection) => {
         if (selection) {
            setCellValue('unit', props.index, 'MILLIGRAMS');
         }
      },
      [setCellValue, props.index]
   );

   return (
      <InteractiveTable.CheckboxCell
         testId={props.testId}
         name={props.name}
         index={props.index}
         defaultValue={props.defaultValue}
         onSelectionChange={handleSelectionChange}
      />
   );
};
